import React, {
  Suspense,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useNavigate } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
// import { Wheel } from "../Wheel";
import InfiniteScroll from "react-infinite-scroll-component";
import { postLotteryDraw } from "../api/lotteryDrawId";
import { useLotteryTicket } from "../api/lotteryTicketList";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import Particles from "react-tsparticles";
import { loadFireworksPreset } from "tsparticles-preset-fireworks";
import yellowt from "@/assets/yellow-t.png";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeDownIcon from "@mui/icons-material/VolumeDown";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import Countdown from "react-countdown";
import { loadFull } from "tsparticles";
import CurrencyFormat from "react-currency-format";
import Confetti from "react-confetti";
import "./animation.css";
import {
  Divider,
  Modal,
  Grid,
  Paper,
  Table,
  TableBody,
  Button,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Container,
  CircularProgress,
} from "@mui/material";
import CountUp from "react-countup";
import arrow from "@/assets/arrow.png";
import ad from "@/assets/add.svg";
import useWindowSize from "react-use/lib/useWindowSize";
import { useAuth } from "../../../lib/auth";
import { Box, createStyles } from "@mui/material";
import sound from "../../../assets/Lottery wheel music sound extended.mp3";
import soundWheelOfFourtune from "../../../assets/suspence sound during jackpot draw.mp3"
import number_sound from "../../../assets/number fall sound.mp3";
import winSound from "../../../assets/iphone.mp3"

import whitet from "@/assets/white-t.png";
import axios from "axios";
import "./wheel.css";
import { TypeOf, any } from "zod";
import { TopHeadingLayout } from "@/components/layout/TopHeadingLayout";
import storage from "@/utils/storage";
import { lotteryData } from "@/features/buyNow/types";
import { BorderRight, ImportantDevices, ScatterPlot } from "@material-ui/icons";
import { isVisible } from "@testing-library/user-event/dist/utils";
import { useParams } from "react-router-dom";
import lotteryFrame from "@/assets/spinnerFrame.png";
import lotteryName from "@/assets/mervIcon.svg";
import rpm from "@/assets/rpmSpinner.svg";
import speed from "@/assets/speedSpinner.svg";
import WinningHistoryWheel from "./winningHistory";
import WinModal from "./winModal";
import LostModal from "./lostModal";
import PrizeModal from "./prizeModal";
import LotteryPoolModal from "./lotteryPoolModal";
import {
  yellow,
  blue,
  red,
  orange,
  green,
  pink,
  purple,
} from "@mui/material/colors";
import JackpotModal from "./jackpotModal";
import JackpotWinModal from "./jackpotWinningModal";
import JackpotLostModal from "./jackpotLostModal";
import LandscapeModeComponent from "@/components/Elements/landscapeComponent";
import { theme } from "@/components/Elements/theme";
// import WinningJackpotTicket from "./jackpotWinning";
import downArrow from "../../../assets/donw_arrow_gold.png";
import clsx from "clsx";
import { debounce, min } from "lodash";
import JackpotMoveToNextLotteryModal from "./jackpotMoveToNextLottery";
import { toast } from "react-toastify";
import moment from "moment";
import { formatNumberWithCommas, getOrdinalSuffix } from "@/utils/utils";
import Swal from "sweetalert2";
import { FixedSizeList as List } from "react-window";
import { tr } from "date-fns/locale";
interface WinningListData {
  userId: string;
  WinAmount: string;
  JackpotRound: string;
  userName: string;
  ticketNumber: string;
  ballNumber: number;
  walletAddress: string;
  createdAt: string;
  jackpotStatus: string;
}

interface SelectedColorData {
  count: number;
  selectedJackpotColourNumber: string;
}

interface LotteryTicketColour {
  message: string;
  data: SelectedColorData[];
}

interface SpinningBallData {
  _id: string;
  endDate: string;
  endTime: string;
  lotteryDrawDate: string;
  randomGeneratedBall: number;
  availableBalls: number[];
}

interface BallPosition {
  number: number;
  left: string;
}

interface Color {
  light: string;
  dark: string;
}

interface LotteryDataType {
  lotteryDrawDate?: string;
  lotteryDrawTime?: string;
  totalDraw?: number;

  jackpotSelected?: boolean;
}

interface JackpotWinningData {
  message?: string;
  data: {
    WinningAmount: number;
    jackpotStatus: boolean;
    jackpotRound: number;
    getJackpotWinTicket: string;
  };
}

interface winningList {
  lotteryStatus?: string;
  userId: string;
  WinAmount: string;
  JackpotRound: string;
  userName: string;
  ticketNumber: string;
  ballNumber: number;
  walletAddress: string;
  createdAt: string;
}

interface winningList1 {
  data: winningList;
}

interface dataLottery {
  data: any;
}
interface JackpotResponse {
  message: string;

  jackpotAccumulatedAmt: string;
}

const dataValue = {
  heading: "",
  subHeading: "",
};

interface BallToDisplay {
  number: number;
  left?: string;
  availableBalls?: number[];
  randomGeneratedBall?: number;
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(1),
  },

  boxShadow: {
    "-webkit-box-shadow": "1px 4px 9px 1px rgba(59,151,187,1)",
    "-moz-box-shadow": "1px 4px 9px 1px rgba(59,151,187,1)",
    "box-shadow": "1px 4px 9px 1px rgba(59,151,187,1)",
    borderRight: "4px solid #3b97bb",
  },
  paperClass: {
    padding: theme.spacing(2),
    textAlign: "center",
    background: "rgba(5, 5, 24, 0.8)",
    borderRadius: "10px",
  },
  first: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    height: 467,
  },
  second: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    height: 150,
  },
  parentPaper: {
    padding: theme.spacing(2),
    margin: "auto",
    maxWidth: 1600,
  },
  availableTickets: {
    border: "0.5px solid rgba(255, 255, 255, 0.2)",
    borderRadius: "10px",
    height: 110,
  },
  noOfTickets: {
    background: "rgba(5, 5, 24, 0.8)",
    borderRadius: "10px",
    height: 180,
  },
  tableContainer: {
    height: "100%",
    background: "#050518",
    borderRadius: 8,
    p: { xs: "0px !important", md: "25px" },
  },
  table: {
    maxWidth: "280",
  },
  tableHeader: {
    color: "#fff",
  },
  LotteryImageLogo: {
    border: "2px solid #3b97bb",
    borderRadius: "9px",
    width: "60px",
    maxWidth: "60px",
    maxHeight: "60px",
    [theme.breakpoints.down("md")]: {
      width: "40px",
      maxWidth: "40px",
      maxHeight: "40px",
    },
  },
  tableData: {
    fontSize: "14px",
    color: "#fff",
    opacity: "0.6",
    borderBottom: "1px solid #0D0D39",
    whiteSpace: "nowrap",
    "& img": {
      verticalAlign: "inherit",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "10px",
      Padding: "2px 4px !important",
    },
  },
  minimumTicket: {
    background: "#3C37FF",
    borderRadius: "10px",
    color: "#fffff",
  },
  logo: {
    width: 50,
  },
  myGridItem: {
    backgroundColor: "rgba(5, 5, 24, 0.8)",
    padding: "30px",
    borderRadius: "20px",
  },
  innerGrid: {
    backgroundColor: "#050518",
    padding: "10px",
    borderRadius: "20px",
  },
  innerGridFirst: {
    backgroundRepeat: "no-repeat",
    height: "auto",
    width: "auto",
    minHeight: "282px",
    minWidth: "282px",
    backgroundPosition: "left bottom",
    [theme.breakpoints.down("sm")]: {
      minHeight: "200px",
      minWidth: "200px",
    },
  },
  substract: {
    border: "1px solid #ffff !important",
    borderRadius: "10px !important",
    color: "#ffff",
  },
  innerGridSecond: {
    backgroundColor: "#050518",
    padding: "10px",
    borderRadius: "20px",
  },
  ticketPrize: {
    background: "rgba(5, 5, 24, 0.8)",
    borderRadius: "10px",
    padding: "30px",
  },
  ticketContainer: {
    maxWidth: "100%",
    width: "100%",
    height: "60px",
    // background: "#FFFF",
    borderRadius: "10px",
    overflow: "hidden",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      height: "auto",
      borderRadius: "6px",
    },
  },
  detailContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "14px",
    padding: "12.86px",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "0px !important",
      padding: "6px 8px !important",
    },
  },
  detailLabel: {
    height: "11px",
    fontFamily: "Ubuntu",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "10px",
    lineHeight: "11px",
    // color: "rgba(27, 28, 45, 0.6)",
    color: "black",
    margin: "0",
    [theme.breakpoints.down("sm")]: {
      fontSize: "9px !important",
      height: "auto",
      lineHeight: "1.25 !important",
    },
  },
  detailNumber: {
    height: "23px",
    fontFamily: "Ubuntu",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "20.3636px",
    lineHeight: "23px",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    color: "black",
    margin: "0",
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px !important",
      height: "auto",
      lineHeight: "1.25 !important",
    },
  },
  detailTime: {
    width: "82px",
    height: "16px",
    fontFamily: "Ubuntu",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "16px",
    color: "#1B1C2D",
    margin: "0",
  },
  list: {
    overflowY: "auto",
    margin: 0,
    padding: "10px",
    listStyle: "none",
    height: "100%",
    maxWidth: "100%",
    backgroundColor: "#000",
    borderRadius: "10px",
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 2px 2px 5px 0 rgba(#fff, 0.5)",
      webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundImage: "linear-gradient(180deg, #3b97bb 0%, #aed1db 99%)",
      boxShadow: "inset 2px 2px 5px 0 rgba(#fff, 0.5)",
      borderRadius: "100px",
    },
    [theme.breakpoints.down("md")]: {
      paddingRight: "15px",
    },
    [theme.breakpoints.down("sm")]: {
      paddingRight: "10px",
    },
  },
  jackpotContainer: {
    display: "flex",
    justifyContent: "space-around",
    width: "100%",
    height: "38px",
    background: "rgba(60, 55, 255, 0.15)",
    marginBottom: "14px",
  },
  jackpotText: {
    width: "99px",
    height: "23px",
    fontFamily: "Ubuntu",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "20.3636px",
    lineHeight: "23px",
    letterSpacing: "0.2em",
    textTransform: "uppercase",
    color: "#27272F",
    margin: "auto",
  },
  ticketDivider: {
    borderRight: "0.46px black dotted",
    position: "absolute",
    right: "20px",
    top: "2%",
    [theme.breakpoints.down("sm")]: {
      right: "20px",
    },
  },
  arrowImage: {
    position: "absolute",
    width: "30px",
    height: "30px",
    transform: "translateX(-50%)",
    [theme.breakpoints.down("sm")]: {
      width: "15px",
      height: "15px",
    },
  },
  polyup: {
    top: "-15px",
    right: "-10px",
    [theme.breakpoints.down("sm")]: {
      top: "-5px",
      right: "5px",
    },
  },
  polydown: {
    bottom: "-15px",
    transform: "rotate(180deg)",
    transformOrigin: "center",
    right: "5px",
    [theme.breakpoints.down("sm")]: {
      bottom: "-5px",
      right: "12px",
    },
  },

  bollMoveBox: {
    border: "4px solid #3b97bb",
    boxShadow: "1px 4px 9px 1px rgba(59, 151, 187, 1)",
    borderRadius: "12px",
    paddingInline: "8px",
    paddingBlock: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    minWidth: "100%",
    boxSizing: "border-box",
    "@media screen and (max-width: 1280px)": {
      padding: "5.2px 8px",
      maxHeight: "50px",
      minHeight: "50px",
    },
    "@media screen and (max-width: 1024px)": {
      padding: "6px 8px",
      minHeight: "43px",
      maxHeight: "43px",
    },
  },

  progressBollBoxOuter: {
    position: "relative",
    minHeight: "120px",
    marginRight: "30px",
  },
  progressBollBox: {
    width: "100%",
    "& canvas": {
      width: "100% !important",
      height: "120px !important",
    },
  },
  ball: {
    width: "auto",
    height: "auto",
    maxWidth: "45px",
    flex: 1,
    aspectRatio: "1",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "18px",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "transform 0.2s ease, border 0.2s ease",
    border: "2px solid transparent",
    position: "relative",
    [theme.breakpoints.down("lg")]: {
      maxWidth: "38px",
      fontSize: "14px",
    },
    [theme.breakpoints.down("md")]: {
      maxWidth: "26px",
      fontSize: "14px",
    },

    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
    },
  },

  winnerBall: {
    border: "3px solid yellow",
    boxShadow: "0px 0px 10px 5px yellow",
    transform: "scale(1.3)",
  },
}));

const data1 = [
  { option: "0", style: { textColor: "#FFFF" } },
  { option: "1", style: { textColor: "#FFFF" } },
  { option: "2", style: { textColor: "#FFFF" } },
  { option: "3", style: { textColor: "#FFFF" } },
  { option: "4", style: { textColor: "#FFFF" } },
  { option: "0", style: { textColor: "#FFFF" } },
  { option: "1", style: { textColor: "#FFFF" } },
  { option: "2", style: { textColor: "#FFFF" } },
  { option: "3", style: { textColor: "#FFFF" } },
  { option: "4", style: { textColor: "#FFFF" } },
];

const data2 = [
  { option: "0", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "1", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "2", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "3", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "4", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "5", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "6", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "7", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "8", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "9", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
];
const data3 = [
  {
    option: "0",
    style: { textColor: "rgba(255,255,255,1.00)", fontWeight: "bold" },
  },
  {
    option: "1",
    style: { textColor: "rgba(255,255,255,1.00)", fontWeight: "bold" },
  },
  {
    option: "2",
    style: { textColor: "rgba(255,255,255,1.00)", fontWeight: "bold" },
  },
  {
    option: "3",
    style: { textColor: "rgba(255,255,255,1.00)", fontWeight: "bold" },
  },
  {
    option: "4",
    style: { textColor: "rgba(255,255,255,1.00)", fontWeight: "bold" },
  },
  {
    option: "5",
    style: { textColor: "rgba(255,255,255,1.00)", fontWeight: "bold" },
  },
  {
    option: "6",
    style: { textColor: "rgba(255,255,255,1.00)", fontWeight: "bold" },
  },
  {
    option: "7",
    style: { textColor: "rgba(255,255,255,1.00)", fontWeight: "bold" },
  },
  {
    option: "8",
    style: { textColor: "rgba(255,255,255,1.00)", fontWeight: "bold" },
  },
  {
    option: "9",
    style: { textColor: "rgba(255,255,255,1.00)", fontWeight: "bold" },
  },
];

const data4 = [
  { option: "0", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "1", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "2", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "3", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "4", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "5", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "6", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "7", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "8", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "9", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
];
const data5 = [
  {
    option: "0",
    style: { textColor: "rgba(255,255,255,1.00)", fontWeight: "bold" },
  },
  {
    option: "1",
    style: { textColor: "rgba(255,255,255,1.00)", fontWeight: "bold" },
  },
  {
    option: "2",
    style: { textColor: "rgba(255,255,255,1.00)", fontWeight: "bold" },
  },
  {
    option: "3",
    style: { textColor: "rgba(255,255,255,1.00)", fontWeight: "bold" },
  },
  {
    option: "4",
    style: { textColor: "rgba(255,255,255,1.00)", fontWeight: "bold" },
  },
  {
    option: "5",
    style: { textColor: "rgba(255,255,255,1.00)", fontWeight: "bold" },
  },
  {
    option: "6",
    style: { textColor: "rgba(255,255,255,1.00)", fontWeight: "bold" },
  },
  {
    option: "7",
    style: { textColor: "rgba(255,255,255,1.00)", fontWeight: "bold" },
  },
  {
    option: "8",
    style: { textColor: "rgba(255,255,255,1.00)", fontWeight: "bold" },
  },
  {
    option: "9",
    style: { textColor: "rgba(255,255,255,1.00)", fontWeight: "bold" },
  },
];
const data6 = [
  { option: "0", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "1", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "2", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "3", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "4", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "5", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "6", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "7", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "8", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
  { option: "9", style: { textColor: "rgb(6, 6, 34, 1)", fontWeight: "bold" } },
];

const backgroundColors = [
  "#E40303",
  "#750787",
  "#1C6CF2",
  "#008026",
  "#FF8C00",
];
const textColors = ["#FFFFF"];
const outerBorderColor = "#eeeee";
const outerBorderWidth = 2;
const outerBorderWidth4 = 6;

const innerBorderColor = "#30261a";
const innerBorderWidth = 2;
const innerRadius = 0;
const radiusLineColor = "#E40303";
const radiusLineWidth = 0;
const fontFamily = "Nunito";
const fontSize1 = 15;
const fontSize2 = 26;
const fontSize3 = 30;
const fontSize4 = 38;
const fontSize5 = 48;
const fontSize6 = 60;
const textDistance1 = 92;
const textDistance2 = 92;
const textDistance3 = 93;
const textDistance4 = 92;
const textDistance5 = 94;
const textDistance6 = 90;

const fontWeight = "bold";
let startDraw = false;
let jackpotStart = false;
let demoCount = 0;
let conditionalPopup = true;

export const Landing = (_DrawWheelPropsData: any) => {
  const Wheel = React.lazy(() =>
    import("../Wheel").then((module) => ({ default: module.Wheel }))
  );

  var result = new Date();
  var targetDate = result.setDate(result.getDate() + 2);
  const countDownDate = new Date(targetDate).getTime();
  const [countDown, setCountDown] = useState(
    countDownDate - new Date().getDate()
  );
  const user: any = useAuth();

  const { id } = useParams();
  const [isWinOpen, setIsWinopen] = React.useState(false);

  const [isJackpotWinOpen, setIsJackpotWinopen] = React.useState(false);
  const [displayTicketsData, setDisplayTicketsData] = React.useState(false);

  const [isLostOpen, setIsLostopen] = React.useState(false);

  const [isJackpotLostOpen, setIsJackpotLostopen] = React.useState(false);

  const [isJackpotMoveToNextLottery, setIsJackpotMoveToNextLottery] =
    React.useState(false);

  const [isPrizeOpen, setIsPrizeOpen] = React.useState(false);
  const [dataLottery, setDataLottery] = React.useState<dataLottery | null>(
    null
  );
  const navigate = useNavigate();
  const [WinnerArray, setWinnerArray] = useState<any[]>([]);
  const [startingOptionIndex, setstartingOptionIndex] = useState(0);

  const [isMuted, setIsMuted] = useState(true);
  console.log(isMuted, "isMuted");

  const [prizesVisible, setPrizesVisible] = useState({
    prize1: false,
    prize2: false,
    prize3: false,
    prize4: false,
    prize5: false,
    prize6: false,
  });

  const resetPrizesVisibility = () => {
    setPrizesVisible({
      prize1: false,
      prize2: false,
      prize3: false,
      prize4: false,
      prize5: false,
      prize6: false,
    });
  };

  const [avgSpeed, setAvgSpeed] = useState(0);
  const [lotterySpin, setLotterySpin] = useState([]);

  console.log(lotterySpin, "lotterySpin");
  const [decelaration, setDecelaration] = useState(0);
  const [isSpinDone, setIsSpinDone] = useState(false);
  const [message, setMessage] = useState(
    "Sorry, you did not win. Fingers crossed for the next Spin."
  );
  const [lotteryNameData, setLotteryName] = useState("");
  const [lotteryImage, setLotteryImage] = useState("");
  const [spinDuration1, setSpinDuration1] = useState(0);
  const [spinDuration2, setSpinDuration2] = useState(0);
  const [spinDuration3, setSpinDuration3] = useState(0);
  const [spinDuration4, setSpinDuration4] = useState(0);
  const [spinDuration5, setSpinDuration5] = useState(0);
  const [spinDuration6, setSpinDuration6] = useState(0);

  const [winnerWithTicket, setWinnerWithTicket] = useState(false);
  const [lotteryPool, setLotteryPool] = useState(false);
  console.log(lotteryPool, "abhahha");
  const [noOfTicketsSold, setNoOfTicketsSold] = useState(0);
  const [percentageOfTicketSold, setPercentageOfTicketSold] = useState(0);
  const [totalPrizeOfTicket, setTotalPrizeOfTicket] = useState(0);
  const [spinningBallData, setSpinningBallData] =
    useState<SpinningBallData | null>(null);
  console.log(spinningBallData, "spinningBallData");
  const [isSpinning, setIsSpinning] = useState(false);
  console.log(isSpinning, "isSpinning");
  const [spinningArray, setSpinningArray] = useState(false);
  const [randomBall, setRandomBall] = useState<number | null>(null);

  const [jackpotWinningData, setJackpotWinningData] = useState<any | null>(
    null
  );
  console.log("jackpotWinningData1", jackpotWinningData);
  const [LotteryData, setLotteryData] = useState<LotteryDataType | null>(null);

  const [jackpotActive, setJackpotActive] = useState(false);
  const [showjackpotModal, setJackpotShowModal] = useState(false);

  const [userData, setUserData] = useState("");

  const [ballWidth, setBallWidth] = useState(0);
  const jackpotWinnerArray = jackpotWinningData?.winnerTicketNumber;
  console.log(jackpotWinnerArray, "jackpotWinnerArrayjackpotWinnerArray");
  const [isPortrait, setIsPortrait] = useState<boolean>(false);
  const [lastLotteryData, setLastLotteryData] =
    useState<JackpotResponse | null>(null);

  const [ballToDisplay, setBallToDisplay] = useState<BallToDisplay[]>([]);
  const [highlightedBallIndex, setHighlightedBallIndex] = useState<
    number | null
  >(null);

  const [isWinnerBallHighlighted, setIsWinnerBallHighlighted] = useState(false);
  const [isJackpotSpin, setIsJackpotSpin] = useState(false);
  const [jackpotAmount, setJackpotAmount] = useState(0);
  const [hasJackpotStarted, setHasJackpotStarted] = useState(false);
  const [isPolling, setIsPolling] = useState(true);
  const [hasLotteryWin, setHasLotteryWin] = useState(false);
  const [hasFreeTicketWin, setHasFreeTicketWin] = useState(false);

  const SkeletonLoader = () => (
    <div style={skeletonContainerStyle}>
      <div style={shimmerEffectStyle}></div>
    </div>
  );

  const skeletonContainerStyle: React.CSSProperties = {
    width: "120px",
    height: "30px",
    borderRadius: "6px",
    position: "relative",
    overflow: "hidden",
  };

  const shimmerEffectStyle: React.CSSProperties = {
    width: "150%",
    height: "100%",
    background:
      "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0) 100%)",
    position: "absolute",
    top: 0,
    left: 0,
    animation: "shimmerMove 1.5s infinite",
  };

  const styles = `
    @keyframes shimmerMove {
      0% { transform: translateX(-100%); }
      100% { transform: translateX(100%); }
    }
  `;
  useEffect(() => {
    if (showjackpotModal && !hasJackpotStarted) {
      setHasJackpotStarted(true);
    }
  }, [showjackpotModal, hasJackpotStarted]);
  const containerRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (containerRef.current) {
      const containerWidth = containerRef.current.offsetWidth;
      setBallWidth(containerWidth / ballToDisplay.length - 20);
    }
  }, [ballToDisplay.length]);

  const scrollRef = useRef<HTMLDivElement>(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const jackpotSelected = LotteryData?.jackpotSelected;

  useEffect(() => {
    if (jackpotSelected) {
      setJackpotActive(true);

      setTimeout(() => {
        setJackpotActive(false);
      }, 5000);
    }
  }, [jackpotSelected]);

  const dynamicWidth = `${ballWidth * 45 + 15}px`;

  useEffect(() => {
    setSpinDuration2((prev) => spinDuration1 - 0.3);
  }, [spinDuration1, avgSpeed]);

  useEffect(() => {
    setSpinDuration3((prev) => spinDuration2 - 0.3);
  }, [spinDuration2, avgSpeed]);

  useEffect(() => {
    setSpinDuration4((prev) => spinDuration3 - 0.3);
  }, [spinDuration3, avgSpeed]);

  useEffect(() => {
    setSpinDuration5((prev) => spinDuration4 - 0.3);
  }, [spinDuration4, avgSpeed]);

  useEffect(() => {
    setSpinDuration6((prev) => spinDuration5 - 0.3);
  }, [spinDuration5, avgSpeed]);
  const classes = useStyles({});

  const [valueData, setValueData] = useState(false);
  const [prizeNumber1, setPrizeNumber1] = useState(0);

  const [prizeNumber2, setPrizeNumber2] = useState(0);
  const [prizeNumber3, setPrizeNumber3] = useState(0);
  const [prizeNumber4, setPrizeNumber4] = useState(0);
  const [prizeNumber5, setPrizeNumber5] = useState(0);
  const [prizeNumber6, setPrizeNumber6] = useState(0);
  const [showModal, setShowModal] = useState(true);
  const [formData, setFormData] = useState({
    lotteryId: "",
    ticketNumber: "",
    lotteryRank: 0,
    lotteryWinningPrize: "",
  });
  const [wheelRotations, setWheelRotations] = useState(WinnerArray.length);
  const [count, setCount] = useState(0);
  const [jackpotCount, setJackpotCount] = useState(0);
  const [countValue, setCountValue] = useState(1);

  const [countWin, setCountWin] = useState(2);
  const [hasCompletedRotation, setHasCompletedRotation] = useState(false);
  const [winningList, setWinningList] = useState<winningList[] | null>(null);

  const [remainingTime, setRemainingTime] = useState();
  console.log(remainingTime, "remainingTime");
  const [startSpinning, setMustSpin] = useState(false);
  const [startSpinning6, setMustSpin6] = useState(false);
  const [startSpinning5, setMustSpin5] = useState(false);

  const [startSpinning4, setMustSpin4] = useState(false);
  const [startSpinning3, setMustSpin3] = useState(false);
  const [startSpinning2, setMustSpin2] = useState(false);
  const [startSpinning1, setMustSpin1] = useState(false);
  const [triggerFetchTicket, setTriggerFetchTicket] = useState(false);
  const [triggerFetch, setTriggerFetch] = useState(false);
  const [showJackpotCount, setShowJackpotCount] = useState(0);
  const [popupCount, setPopupCount] = useState(0);
  const [isDataReady, setIsDataReady] = useState(false);
  const [triggerSecondEffect, setTriggerSecondEffect] = useState(false);
  const [saleEndDateTime, setSaleEndDateTime] = useState<number | null>(null);
  
  console.log(saleEndDateTime, "saleEndDateTime");
  const [tickets, setTickets] = React.useState<any[]>([]);
  console.log(tickets, "ticketstickets")
  const [ticketMsg, setTicketsMsg] = useState("");
  const [hasMore, setHasMore] = React.useState(true);
  const [page, setPage] = React.useState(1);
  const [totalCount, setTotalCount] = React.useState(0);
  const { width, height } = useWindowSize();
  const rowRefs = useRef<(HTMLTableRowElement | null)[]>([]);
  const tableContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const activeRow = rowRefs.current[count];
    const container = tableContainerRef.current;

    if (activeRow && container) {
      //    activeRow.scrollIntoView({
      //   behavior: "smooth",
      //   block: "nearest",
      // });
      const containerTop = container.scrollTop;
      const containerBottom = containerTop + container.clientHeight;

      const rowTop = activeRow.offsetTop;
      const rowBottom = rowTop + activeRow.clientHeight;

      if (rowTop < containerTop) {
        container.scrollTo({
          top: rowTop,
          behavior: "smooth",
        });
      } else if (rowBottom > containerBottom) {
        container.scrollTo({
          top: rowBottom - container.clientHeight,
          behavior: "smooth",
        });
      }
    }
  }, [count]);

  const particlesInit = useCallback(async (engine) => {
    await loadFireworksPreset(engine);
  }, []);

  const audioElement = useRef<HTMLAudioElement | null>(null);
  const finalSpinAudio = useRef<HTMLAudioElement | null>(null);
  const [audio] = useState(new Audio(number_sound));
  useEffect(() => {
    finalSpinAudio.current = new Audio(soundWheelOfFourtune);
    finalSpinAudio.current.preload = "auto";
  }, []);

  const toggleMute = () => {
    setIsMuted(!isMuted);
  };

  // useEffect(() => {
  //   if (audioElement.current) {
  //     const isAnySpinning =
  //       startSpinning1 ||
  //       startSpinning2 ||
  //       startSpinning3 ||
  //       startSpinning4 ||
  //       startSpinning5 ||
  //       startSpinning6;

  //     if (isMuted || !isAnySpinning) {
  //       audioElement.current.pause();
  //       audioElement.current.currentTime = 0;
  //     } else {
  //       audioElement.current.play().catch((error) => {
  //         console.error("Audio play error:", error);
  //       });
  //     }
  //   }
  // }, [
  //   isMuted,
  //   startSpinning1,
  //   startSpinning2,
  //   startSpinning3,
  //   startSpinning4,
  //   startSpinning5,
  //   startSpinning6,
  // ]);


  useEffect(() => {
    if (!audioElement.current) return;

    const isAnySpinning =
      startSpinning1 ||
      startSpinning2 ||
      startSpinning3 ||
      startSpinning4 ||
      startSpinning5 ||
      startSpinning6;

    // Cleanup timeout reference
    let stopFinalSpinTimeout: ReturnType<typeof setTimeout> | null = null;

    if (isMuted || !isAnySpinning) {
      audioElement.current.pause();
      audioElement.current.currentTime = 0;

      if (finalSpinAudio.current) {
        finalSpinAudio.current.pause();
        finalSpinAudio.current.currentTime = 0;
        finalSpinAudio.current.loop = false;
      }
    } else {
      if (isJackpotSpin && finalSpinAudio.current) {
        // Pause normal spin audio
        audioElement.current.pause();
        audioElement.current.currentTime = 0;

        // Loop the final spin audio for 12 seconds
        finalSpinAudio.current.loop = true;
        finalSpinAudio.current.currentTime = 0;
        finalSpinAudio.current.play().catch((error) =>
          console.error("Final spin audio play error:", error)
        );

        // Stop it after 12 seconds
        stopFinalSpinTimeout = setTimeout(() => {
          if (finalSpinAudio.current) {
            finalSpinAudio.current.pause();
            finalSpinAudio.current.currentTime = 0;
            finalSpinAudio.current.loop = false;
          }
        }, 29000);
      } else {
        if (finalSpinAudio.current) {
          finalSpinAudio.current.pause();
          finalSpinAudio.current.currentTime = 0;
          finalSpinAudio.current.loop = false;
        }

        audioElement.current.play().catch((error) =>
          console.error("Audio play error:", error)
        );
      }
    }

    // Cleanup when dependencies change
    return () => {
      if (stopFinalSpinTimeout) {
        clearTimeout(stopFinalSpinTimeout);
      }
    };
  }, [
    isMuted,
    startSpinning1,
    startSpinning2,
    startSpinning3,
    startSpinning4,
    startSpinning5,
    startSpinning6,
    isJackpotSpin,
  ]);


  const handleWinClose = () => {
    setIsWinopen(false);
  };

  const handleJackpotWinClose = () => {
    setIsJackpotWinopen(false);
  };

  const handleLostClose = () => {
    setIsLostopen(false);
  };

  const handleJackpotLostClose = () => {
    setIsJackpotLostopen(false);
  };

  const handleJackpotMoveToNextLotteryClose = () => {
    setIsJackpotMoveToNextLottery(false);
  };

  const handleLotteryPoolClose = () => {
    setLotteryPool(false);
  };

  const handlePrizeClose = () => {
    setIsPrizeOpen(false);
  };

  const handleJackpotModalClose = () => {
    setJackpotShowModal(false);
  };

  useEffect(() => {
    const getLotteryData = async () => {
      let token = storage.getToken();

      try {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const res = await axios.get(
          `${process.env.API_URL_PREFIX}/api/v1/user/lotteryDetailById/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
              TimeZone: timezone,
            },
          }
        );
        setLotteryData(res.data.data);
      } catch (err) {
        console.log(err);
      }
    };

    getLotteryData();
  }, [id]);

  useEffect(() => {
    let token = storage.getToken();

    const fetchLotteryData = async () => {
      try {
        const response = await axios.get(
          `${process.env.API_URL_PREFIX}/api/v1/user/drawlist/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );
        setLotterySpin(response.data.drawPrize);
        setLotteryName(response.data.lotteryName);
        setLotteryImage(response.data.lotteryImage);
      } catch (error) {
        console.error(error);
      }
    };

    if (!LotteryData?.lotteryDrawDate) return;

    const drawTime = moment(LotteryData.lotteryDrawDate).toDate();

    const now = new Date();
    const timeUntilDraw = drawTime.getTime() - now.getTime();

    fetchLotteryData();
    if (timeUntilDraw <= 0) {
      fetchLotteryData();
    } else {
      const timer = setTimeout(() => {
        fetchLotteryData();
      }, timeUntilDraw);

      return () => clearTimeout(timer);
    }
  }, [id, LotteryData?.lotteryDrawDate]);

  const getData = async () => {
    let token = storage.getToken();

    await axios
      .get(`${process.env.API_URL_PREFIX}/api/v1/user/lottery/` + id, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        if (res?.data?.data?.lotteryDrawTktNum.length) {
          setWinnerArray(res.data.data.lotteryDrawTktNum);
        } else {
          setWinnerArray(res.data.data.lotteryDrawTktNumStore);
        }
      })

      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (isJackpotWinOpen || isJackpotLostOpen || isJackpotMoveToNextLottery) {
      const timeoutId = setTimeout(() => {
        scrollRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 3000);

      return () => clearTimeout(timeoutId);
    }
  }, [isJackpotWinOpen, isJackpotLostOpen, isJackpotMoveToNextLottery]);

  const getRPMData = async () => {
    let token = storage.getToken();

    await axios
      .get(
        `${process.env.API_URL_PREFIX}/api/v1/user/rpmAndbreakAverage/` + id,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        setAvgSpeed(res.data.avgSpeed);
        setDecelaration(res.data.deceleration);
      })

      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    let pollingInterval;

    const getBallData = async () => {
      let token = storage.getToken();

      try {
        const res = await axios.get(
          `${process.env.API_URL_PREFIX}/api/v1/admin/fetchSpinningBalls/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );

        const fetchedData = res.data.data[0];

        setSpinningBallData(fetchedData);

        if (fetchedData.randomGeneratedBall !== null) {
          clearInterval(pollingInterval);
          setIsPolling(false);
        }
      } catch (err) {
        console.log("Error fetching spinning ball data:", err);
      }
    };

    if (isPolling) {
      getBallData();
      pollingInterval = setInterval(getBallData, 5000);
    }

    return () => {
      clearInterval(pollingInterval);
    };
  }, [id, isPolling]);

  useEffect(() => {
    if (spinningBallData && spinningBallData.availableBalls) {
      const { availableBalls, randomGeneratedBall } = spinningBallData;

      let ballsToDisplay = [...availableBalls];
      // if (
      //   randomGeneratedBall !== null &&
      //   !ballsToDisplay.includes(randomGeneratedBall)
      // ) {
      //   ballsToDisplay.push(randomGeneratedBall);
      // }

      ballsToDisplay.sort((a, b) => a - b);

      const mappedBalls = ballsToDisplay.map((number, index) => ({
        number,
        left: `${index * 20}%`,
      }));
      console.log(mappedBalls, "mappedBalls");
      setBallToDisplay(mappedBalls);
    }
  }, [spinningBallData]);

  const colors = [
    { light: yellow[700], dark: yellow[900] },
    { light: blue[700], dark: blue[900] },
    { light: red[700], dark: red[900] },
    { light: pink[900], dark: pink[800] },
    { light: orange[700], dark: orange[900] },
    { light: green[700], dark: green[900] },
    { light: purple[700], dark: purple[900] },
  ];

  const isAnimatingRef = useRef(false);
  const highlightedBallIndexRef = useRef<number | null>(null);

  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const updateHighlightedBall = debounce((newIndex) => {
    setHighlightedBallIndex(newIndex);
  }, 300);
  const popAndHighlightBalls = () => {
    if (
      !spinningBallData ||
      ballToDisplay.length === 0 ||
      isAnimatingRef.current
    )
      return;

    isAnimatingRef.current = true;

    const totalDuration = 28000;
    const intervalDuration = 400;
    const iterations = Math.floor(totalDuration / intervalDuration);
    let currentIteration = 0;

    intervalRef.current = setInterval(() => {
      if (currentIteration >= iterations) {
        clearInterval(intervalRef.current!);
        intervalRef.current = null;
        setHighlightedBallIndex(null);
        setIsWinnerBallHighlighted(true);
        isAnimatingRef.current = false;
        return;
      }

      const randomIndex = Math.floor(Math.random() * ballToDisplay.length);
      highlightedBallIndexRef.current = randomIndex;

      updateHighlightedBall(randomIndex);

      currentIteration++;
    }, intervalDuration);

    setTimeout(() => {
      clearInterval(intervalRef.current!);
      intervalRef.current = null;
      setHighlightedBallIndex(null);
      setIsWinnerBallHighlighted(true);
      isAnimatingRef.current = false;
    }, totalDuration);
  };

  useEffect(() => {
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      let token = storage.getToken();
      await axios
        .get(
          `${process.env.API_URL_PREFIX}/api/v1/user/getJackpotPlayAmount/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((res) => {
          setLastLotteryData(res.data.data);
          setJackpotAmount(res?.data?.data?.jackpotAccumulatedAmt);
        })
        .catch((err) => {
          console.error(err);
        });
    };
    fetchData();
  }, []);

  useEffect(() => {
    // getData();
    getTicketPurchaseSummary();
  }, [triggerFetch]);

  useEffect(() => {
    if (LotteryData?.lotteryDrawDate) {
      const lotteryDrawTime = new Date(LotteryData?.lotteryDrawDate).getTime();
      const currentTime = new Date().getTime();
      const timeRemaining = lotteryDrawTime - currentTime;

      if (timeRemaining > 0) {
        const timer = setTimeout(() => {
          setTriggerFetch((prev) => !prev);
        }, timeRemaining);

        return () => clearTimeout(timer);
      } else {
        setTriggerFetch((prev) => !prev);
      }
    }
  }, [LotteryData?.lotteryDrawDate]);
  let token = storage.getToken();
  const LIMIT = 20;


  const fetchTickets = async (pageToFetch: number) => {
    try {
      const res = await axios.get(
        `${process.env.API_URL_PREFIX}/api/v1/user/lotteryTiketNumberList/${id}?page=${pageToFetch}&limit=${LIMIT}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      if (res.data.data == undefined) {
        setTicketsMsg(res.data.message);
      }
      const newTickets = res?.data?.data || [];
      console.log(newTickets, "newTickets")
      setTickets((prev) => {
        const ids = new Set(prev.map((t) => t._id));
        const filtered = newTickets.filter((t) => !ids.has(t._id));
        return [...prev, ...filtered];
      });

      setTotalCount(res.data.totalCount);

      if (pageToFetch * LIMIT >= res.data.totalCount) {
        setHasMore(false);
      }else {
      setPage(pageToFetch + 1);
    }

      // setPage((prev) => prev + 1);

      setTriggerSecondEffect(true);
    } catch (err: any) {
      setHasMore(false);
      if (err.response?.status === 400 && err.response?.data?.message) {
        Swal.fire({
          icon: "error",
           title: "Opps!",
          text: err.response.data.message,
          background: "black",
          color: "#fff",
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then((result) => {
          if (result.isConfirmed) {
            console.log("User pressed OK");
            setTriggerSecondEffect(true);
          }
        });
      }
    }
  };

  useEffect(() => {
    setTickets([]);
    setPage(1);
    setHasMore(true);
    fetchTickets(1);
  }, [id]);
  useEffect(() => {
    if (!saleEndDateTime) return;

    const now = Math.floor(Date.now() / 1000); 
    const delay: any = (saleEndDateTime - now) * 1000; 

    if (delay <= 0) {
      // If time already passed
      fetchTickets(1);
    } else {
      const timer = setTimeout(() => {
        fetchTickets(1);
      }, delay);

      return () => clearTimeout(timer); // clean up
    }
  }, [saleEndDateTime]);


  useEffect(() => {
    const getUserData = async () => {
      let token = storage.getToken();
      try {
        const response = await axios.get(
          `${process.env.API_URL_PREFIX}/api/v1/user/userdetail`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );
        setUserData(response?.data?.data?._id);
        setTriggerFetchTicket(true);
      } catch (err) {
        console.log(err);
      }
    };
    getUserData();
  }, []);

  useEffect(() => {
    if (!triggerSecondEffect) return;

    const fetchRemainingTime = async () => {
      let token = storage.getToken();
      try {
        const res = await axios.get(
          `${process.env.API_URL_PREFIX}/api/v1/user/endDateDrawDateTime/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );

        setRemainingTime(res?.data?.drawDateDateTime);
        setSaleEndDateTime(res?.data?.endDateInSec);
        const interval = setInterval(() => {
          const newCurrentTime = Math.floor(Date.now() / 1000);
          const newTimeDifference = res?.data?.drawDateInSec - newCurrentTime;

          if (newTimeDifference <= 0) {
            clearInterval(interval);
            setShowModal(false);
            setLotteryPool(true);
            getRPMData();
          }
        }, 1000);

        return () => clearInterval(interval);
      } catch (err) {
        console.log(err);
      }
    };

    fetchRemainingTime();
  }, [triggerSecondEffect, id]);

  const setPrizeNumbers = async (values: any[]) => {
    return new Promise((_resolve) => {
      values.forEach((value: any, index: number) => {
        const setter = eval(`setPrizeNumber${index + 1}`);
        setter(value);
      });
    });
  };

  const setMustSpins = async (values: any[]) => {
    return new Promise((_resolve) => {
      values.forEach((_value: any, index: number) => {
        const setter = eval(`setMustSpin${index + 1}`);
        setter(true);
      });
    });
  };

  const setMustSpinsStop = (values: any[]) => {
    values.forEach((_value: any, index: number) => {
      const setter = eval(`setMustSpin${index + 1}`);
      setter(false);
    });
  };
  useEffect(() => {
    if (startDraw || jackpotStart) {
      if (
        hasCompletedRotation &&
        Object.values(prizesVisible).every((v) => v === true) &&
        WinnerArray.length - 1 !== count
      ) {
        setTimeout(() => {
          setCount((prevIndex) => prevIndex + 1);
          setCountWin((prevIndex) => prevIndex + 1);
          resetPrizesVisibility();
          setHasCompletedRotation(false);
          setCountValue((prevIndex) => prevIndex + 1);
        }, 10000);
      }
      const spinNextWheel = async () => {
        if (wheelRotations >= 0 && WinnerArray.length > 0) {
          await handleSpinClick(WinnerArray[count]);
        }
      };

      if (!hasCompletedRotation) {
        spinNextWheel();
      }
    }
  }, [WinnerArray, hasCompletedRotation, startDraw, jackpotStart]);

  const handleSpinClick = async (value: any) => {
    setIsMuted(false);
    setIsSpinning(true);

    if (!startSpinning) {
      setMustSpin1(true);
      setTimeout(() => {
        setMustSpin2(true);
      }, 1000);
      setTimeout(() => {
        setMustSpin3(true);
      }, 2000);
      setTimeout(() => {
        setMustSpin4(true);
      }, 3000);
      setTimeout(() => {
        setMustSpin5(true);
      }, 4000);
      setTimeout(() => {
        setMustSpin6(true);
      }, 5000);
      let valuedata: number[];
      valuedata = Array.from(value?.toString()).map(Number);
      setMustSpins([0, 1, 2, 3, 4, 5]);
      setPrizeNumbers(valuedata);
    }
  };

  useEffect(() => {
    let token = storage.getToken();

    if (
      WinnerArray.length > 0 &&
      Object.values(prizesVisible).every((v) => v === true)
    ) {
      setHasCompletedRotation(true);

      setFormData({
        lotteryId: id?.toString() || "",
        ticketNumber: dataLottery?.data[count] ? dataLottery?.data[count] : "",
        lotteryRank: count,
        lotteryWinningPrize: "1000",
      });
      if (wheelRotations !== 0) setWheelRotations((prevIndex) => prevIndex - 1);
      else if (wheelRotations === 0) setWheelRotations(0);

      if (conditionalPopup == true) {
        postWinnerStatus(WinnerArray[count]);
        setTimeout(() => {
          getWinner();
        }, 2000);
      }

      setMustSpinsStop([0, 1, 2, 3, 4, 5]);
      if (WinnerArray.length === count + 1) {
        setMessage(
          "Sorry, you did not win. Try your luck in the next Lottery."
        );
      }
    }
  }, [Object.values(prizesVisible).every((v) => v === true)]);
  const numnerOfSpinner = LotteryData?.totalDraw;

  const postWinnerStatus = async (ticketNumber) => {
    let token = storage.getToken();
    let formData = { ticketNumber: ticketNumber };

    try {
      const res = await axios.get(
        `${process.env.API_URL_PREFIX}/api/v1/user/userWinLooseStatus`,

        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
          params: {
            lotteryId: id,
            ticketNumber: ticketNumber,
          },
        }
      );

      console.log(res?.data, "resWinLoose");
      const winnerData = res?.data?.data?.winningStatus;
      setHasLotteryWin(res?.data?.data?.winningStatus);
      setHasFreeTicketWin(res?.data?.data?.freeWinTicket);
      const hasLotteryWin1 = res?.data?.data?.winningStatus;
      const hasFreeTicketWin1 = res?.data?.data?.freeWinTicket;
      if (hasLotteryWin1 && hasFreeTicketWin1) {
        setIsWinopen(true);
      } else if (hasLotteryWin1 && !hasFreeTicketWin1) {
        setIsWinopen(true);
      } else if (!hasLotteryWin1 && hasFreeTicketWin1) {
        setIsWinopen(true);
      } else {
        setIsLostopen(true);
      }

      if (hasLotteryWin1 || hasFreeTicketWin1) {
        setTimeout(() => {
          setIsWinopen(false);
        }, 8000);
      } else {
        setTimeout(() => {
          setIsLostopen(false);
        }, 8000);
      }

      let lotteryStatus = res?.data?.data?.lotteryStatus;
      console.log(lotteryStatus, "lotteryStatus");

      if (winnerData === false) {
        demoCount = demoCount - 1;

        setPopupCount((prevCount) => {
          const newCount = prevCount + 1;
          if (newCount === numnerOfSpinner && jackpotSelected == true) {
            getJackpotWinningData();

            setTimeout(() => {
              setJackpotShowModal(true);
            }, 8000);
          }
          return newCount;
        });
      } else if (winnerData === true) {
        setShowJackpotCount(showJackpotCount + 1);
        demoCount = demoCount - 1;

        setPopupCount((prevCount) => {
          const newCount = prevCount + 1;
          if (newCount === numnerOfSpinner && jackpotSelected == true) {
            getJackpotWinningData();

            setTimeout(() => {
              setJackpotShowModal(true);
            }, 8000);
          }
          return newCount;
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getWinner = async () => {
    let token = storage.getToken();
    await axios
      .get(
        `${process.env.API_URL_PREFIX}/api/v1/user/lotteryWinnerList/` + id,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        setWinningList(res?.data.data);
        setIsSpinDone(true);
      })

      .catch((err) => {
        console.log(err);
      });
  };

  const getChildComp1 = useMemo(
    () => (
      <Suspense fallback={<div>Loading Wheel...</div>}>
        <Wheel
          continueSpin={(avgSpeed / 60) * avgSpeed * 10 * 6}
          mustStartSpinning={startSpinning6}
          prizeNumber={prizeNumber1}
          data={data1}
          innerRadius={82}
          heightPercentage={74}
          widthPercentage={74}
          width={400}
          height={400}
          stopSpinTime={15000}
          fontSize={fontSize1}
          textDistance={textDistance1}
          perpendicularText={true}
          startingOptionIndex={0}
          backgroundColors={backgroundColors}
          onStopSpinning={() => {
            setPrizesVisible((prev) => ({ ...prev, prize1: true }));
            audio.play();
          }}
        />
      </Suspense>
    ),
    [startSpinning6]
  );

  const getChildComp2 = useMemo(
    () => (
      <Suspense fallback={<div>Loading Wheel...</div>}>
        <Wheel
          continueSpin={(avgSpeed / 60) * avgSpeed * 10 * 5}
          mustStartSpinning={startSpinning5}
          prizeNumber={prizeNumber2}
          data={data2}
          innerRadius={79}
          heightPercentage={65}
          widthPercentage={65}
          fontSize={fontSize2}
          width={350}
          height={350}
          stopSpinTime={12000}
          textDistance={textDistance2}
          perpendicularText={true}
          startingOptionIndex={0}
          backgroundColors={backgroundColors}
          onStopSpinning={() => {
            setPrizesVisible((prev) => ({ ...prev, prize2: true }));
            audio.play();
          }}
        />
      </Suspense>
    ),
    [startSpinning5]
  );
  const getChildComp3 = useMemo(
    () => (
      <Suspense fallback={<div>Loading Wheel...</div>}>
        {" "}
        <Wheel
          continueSpin={(avgSpeed / 60) * avgSpeed * 10 * 4}
          mustStartSpinning={startSpinning4}
          prizeNumber={prizeNumber3}
          data={data3}
          innerRadius={76}
          heightPercentage={56}
          fontSize={fontSize3}
          widthPercentage={56}
          width={300}
          height={300}
          stopSpinTime={9000}
          textDistance={textDistance3}
          perpendicularText={true}
          startingOptionIndex={0}
          backgroundColors={backgroundColors}
          onStopSpinning={() => {
            setPrizesVisible((prev) => ({ ...prev, prize3: true }));
            audio.play();
          }}
        />{" "}
      </Suspense>
    ),
    [startSpinning4]
  );
  const getChildComp4 = useMemo(
    () => (
      <Suspense fallback={<div>Loading Wheel...</div>}>
        {" "}
        <Wheel
          continueSpin={(avgSpeed / 60) * avgSpeed * 10 * 3}
          mustStartSpinning={startSpinning3}
          prizeNumber={prizeNumber4}
          data={data4}
          innerRadius={73}
          fontSize={fontSize4}
          heightPercentage={48}
          widthPercentage={48}
          width={250}
          height={250}
          stopSpinTime={6000}
          textDistance={textDistance4}
          perpendicularText={true}
          startingOptionIndex={0}
          backgroundColors={backgroundColors}
          onStopSpinning={() => {
            setPrizesVisible((prev) => ({ ...prev, prize4: true }));
            audio.play();
          }}
        />{" "}
      </Suspense>
    ),
    [startSpinning3]
  );
  const getChildComp5 = useMemo(
    () => (
      <Suspense fallback={<div>Loading Wheel...</div>}>
        {" "}
        <Wheel
          continueSpin={(avgSpeed / 60) * avgSpeed * 10 * 2}
          mustStartSpinning={startSpinning2}
          prizeNumber={prizeNumber5}
          data={data5}
          innerRadius={70}
          fontSize={fontSize5}
          heightPercentage={39}
          widthPercentage={39}
          width={200}
          height={200}
          stopSpinTime={3000}
          textDistance={textDistance5}
          perpendicularText={true}
          startingOptionIndex={0}
          backgroundColors={backgroundColors}
          onStopSpinning={() => {
            setPrizesVisible((prev) => ({ ...prev, prize5: true }));
            audio.play();
          }}
        />
      </Suspense>
    ),
    [startSpinning2]
  );
  const getChildComp6 = useMemo(
    () => (
      <Suspense fallback={<div>Loading Wheel...</div>}>
        {" "}
        <Wheel
          continueSpin={(avgSpeed / 60) * avgSpeed * 10}
          mustStartSpinning={startSpinning1}
          prizeNumber={prizeNumber6}
          data={data6}
          innerRadius={70}
          fontSize={15}
          heightPercentage={29}
          widthPercentage={29}
          width={180}
          height={180}
          stopSpinTime={0}
          textDistance={80}
          perpendicularText={true}
          startingOptionIndex={0}
          backgroundColors={backgroundColors}
          onStopSpinning={() => {
            setPrizesVisible((prev) => ({ ...prev, prize6: true }));
            audio.play();
          }}
        />
      </Suspense>
    ),
    [startSpinning1]
  );

  const handleStartDraw = () => {
    if (WinnerArray && WinnerArray.length == 0) {
      getData();
    }
    startDraw = true;

    setLotteryPool(false);
  };

  const getJackpotWinningData = async () => {
    let token = storage.getToken();

    try {
      const res = await axios.get(
        `${process.env.API_URL_PREFIX}/api/v1/user/playjackpot`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
          params: {
            lotteryId: id,
          },
        }
      );

      setJackpotWinningData(res.data);
      setRandomBall(res?.data?.randomBall);

      setIsDataReady(true);
    } catch (err: unknown) {
      if (axios.isAxiosError(err)) {
        console.log(
          "Error fetching lottery data:",
          err.response ? err.response.data : err.message
        );
      } else {
        console.log("Unexpected error:", err);
      }
    }
  };

  const handleStartJackpotDraw = async () => {
    let token = storage.getToken();
    if (isDataReady == true) {
      handleJackpotModalClose();
      setIsJackpotSpin(true);
      setCount(0);
      setJackpotCount(1);
      jackpotStart = true;
      setHasCompletedRotation(false);
      conditionalPopup = false;
      resetPrizesVisibility();

      if (jackpotWinnerArray != null) {
        setWinnerArray([jackpotWinnerArray]);
      }

      popAndHighlightBalls();

      setTimeout(() => {
        setTimeout(() => {
          if (jackpotWinningData?.winningStatus === 1) {
            setIsJackpotWinopen(true);
            setDisplayTicketsData(true);
            setIsJackpotLostopen(false);
            setIsJackpotMoveToNextLottery(false);
          } else if (jackpotWinningData?.winningStatus === 2) {
            setIsJackpotWinopen(false);
            setIsJackpotLostopen(false);
            setIsJackpotMoveToNextLottery(true);
            setDisplayTicketsData(true);
          } else {
            setIsJackpotWinopen(false);
            setIsJackpotLostopen(true);
            setIsJackpotMoveToNextLottery(false);
            setDisplayTicketsData(true);
          }
        }, 3500);
      }, 25000);
    }
  };

  const getTicketPurchaseSummary = async () => {
    let token = storage.getToken();
    await axios
      .get(
        `${process.env.API_URL_PREFIX}/api/v1/user/lotteryTicketPurchaseSummary/` +
        id,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        setNoOfTicketsSold(res?.data?.numOfTicketSold);
        setPercentageOfTicketSold(res?.data?.percentageTktSale);
        setTotalPrizeOfTicket(
          res?.data?.sumTicketPrice !== null ? res?.data?.sumTicketPrice : 0
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const checkOrientation = () => {
    setIsPortrait(window.innerHeight > window.innerWidth);
  };

  useEffect(() => {
    checkOrientation();
    window.addEventListener("resize", checkOrientation);
    return () => {
      window.removeEventListener("resize", checkOrientation);
    };
  }, []);

  const memoizedTickets = useMemo(() => {
    return tickets?.map((row, index) => {
      let currentIndex = 0;

      const colorIndex = parseInt(row.selectedJackpotColourNumber) - 1;
      const bgColor = colors[colorIndex]?.light || "#ffffff";

      return (
        <Grid item xs={6} md={6} key={index}>
          <Paper
            elevation={3}
            className={classes.ticketContainer}
            sx={{
              backgroundColor: bgColor,
              color: "black",
              textAlign: "left",
            }}
          >
            <div className={classes.detailContainer}>
              <div>
                <Typography variant="body2" className={classes.detailLabel}>
                  Ticket no.
                </Typography>
                <Typography variant="h6" className={classes.detailNumber}>
                  {row.ticketNumber}
                </Typography>
              </div>
              <Divider
                className={classes.ticketDivider}
                orientation="vertical"
              />
            </div>

            <div
              style={{
                flex: 1,
                borderRadius: "0 10px 10px 0",
                position: "absolute",
                right: 0,
                left: 0,
                top: 0,
                bottom: 0,
              }}
            >
              <img
                src={arrow}
                alt="Up Arrow"
                className={`${classes.arrowImage} ${classes.polyup}`}
              />
              <img
                src={arrow}
                alt="Down Arrow"
                className={`${classes.arrowImage} ${classes.polydown}`}
              />
            </div>
          </Paper>
        </Grid>
      );
    });
  }, [tickets, classes]);
  return (
    <>
      {isPortrait ? (
        <LandscapeModeComponent />
      ) : (
        <Box>
          <Box
            className="wheel-container"
            id="container"
            sx={{
              borderRadius: "10px",
              px: { md: "30px", xs: "15px" },
              paddingBlock: "100px 40px !important",
              [theme.breakpoints.down("md")]: {
                paddingBlock: "20px 20px !important",
              },
            }}
          >
            <Box
              sx={{
                borderRadius: "10px",
                padding: {
                  md: "30px",
                  xs: "15px",
                },
                backgroundColor: isWinOpen
                  ? "transparent"
                  : "rgba(5, 5, 24, 0.8)",
              }}
            >
              <Grid
                container
                spacing={{ lg: 4, md: 3, sm: 2, xs: 2 }}
              // sx={{
              //   [theme.breakpoints.down("md")]: {
              //     minHeight: "420px",
              //   },
              // }}
              >
                <Grid item xs={3.5} md={3.3}>
                  <Box
                    className="lotterynumber-div "
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexFlow: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    {/* numbering count */}
                    <Box className="bollBoxContainer">
                      <Box
                        id="outer"
                        className={`${classes.boxShadow} bollBoxOuter`}
                      >
                        <Box
                          className={`${classes.boxShadow} bollBox`}
                          sx={{
                            background: prizesVisible.prize1
                              ? "#750787"
                              : "transparent",
                          }}
                        >
                          {prizesVisible.prize1 ? (
                            <CountUp start={0} end={prizeNumber1} delay={0}>
                              {({ countUpRef }) => (
                                <Box
                                  sx={{
                                    color: "#FFFF",
                                    fontSize: {
                                      xs: "20px",
                                      md: "30px",
                                      lg: "40px",
                                    },
                                    fontWeight: "bold",
                                  }}
                                >
                                  <span ref={countUpRef} />
                                </Box>
                              )}
                            </CountUp>
                          ) : (
                            ""
                          )}
                        </Box>

                        <Box
                          className={`${classes.boxShadow} bollBox`}
                          sx={{
                            background: prizesVisible.prize2
                              ? "#1C6CF2"
                              : "transparent",
                          }}
                        >
                          {prizesVisible.prize2 ? (
                            <CountUp start={0} end={prizeNumber2} delay={0}>
                              {({ countUpRef }) => (
                                <Box
                                  sx={{
                                    color: "#FFFF",
                                    fontSize: {
                                      xs: "20px",
                                      md: "30px",
                                      lg: "40px",
                                    },
                                    fontWeight: "bold",
                                  }}
                                >
                                  <span ref={countUpRef} />
                                </Box>
                              )}
                            </CountUp>
                          ) : (
                            ""
                          )}
                        </Box>

                        <Box
                          className={`${classes.boxShadow} bollBox`}
                          sx={{
                            background: prizesVisible.prize3
                              ? "#008026"
                              : "transparent",
                          }}
                        >
                          {prizesVisible.prize3 ? (
                            <CountUp start={0} end={prizeNumber3} delay={0}>
                              {({ countUpRef }) => (
                                <Box
                                  sx={{
                                    color: "#FFFF",
                                    fontSize: {
                                      xs: "20px",
                                      md: "30px",
                                      lg: "40px",
                                    },
                                    fontWeight: "bold",
                                  }}
                                >
                                  <span ref={countUpRef} />
                                </Box>
                              )}
                            </CountUp>
                          ) : (
                            ""
                          )}
                        </Box>

                        <Box
                          className={`${classes.boxShadow} bollBox`}
                          sx={{
                            background: prizesVisible.prize4
                              ? "#E40303"
                              : "transparent",
                          }}
                        >
                          {prizesVisible.prize4 ? (
                            <CountUp start={0} end={prizeNumber4} delay={0}>
                              {({ countUpRef }) => (
                                <Box
                                  sx={{
                                    color: "#FFFF",
                                    fontSize: {
                                      xs: "20px",
                                      md: "30px",
                                      lg: "40px",
                                    },
                                    fontWeight: "bold",
                                  }}
                                >
                                  <span ref={countUpRef} />
                                </Box>
                              )}
                            </CountUp>
                          ) : (
                            ""
                          )}
                        </Box>

                        <Box
                          className={`${classes.boxShadow} bollBox`}
                          sx={{
                            background: prizesVisible.prize5
                              ? "#FF8C00"
                              : "transparent",
                          }}
                        >
                          {prizesVisible.prize5 ? (
                            <CountUp start={0} end={prizeNumber5} delay={0}>
                              {({ countUpRef }) => (
                                <Box
                                  sx={{
                                    color: "#FFFF",
                                    fontSize: {
                                      xs: "20px",
                                      md: "30px",
                                      lg: "40px",
                                    },
                                    fontWeight: "bold",
                                  }}
                                >
                                  <span ref={countUpRef} />
                                </Box>
                              )}
                            </CountUp>
                          ) : (
                            ""
                          )}
                        </Box>
                        <Box
                          className={`${classes.boxShadow} bollBox`}
                          sx={{
                            background: prizesVisible.prize6
                              ? "#e55934"
                              : "transparent",
                          }}
                        >
                          {prizesVisible.prize6 ? (
                            <CountUp start={0} end={prizeNumber6} delay={0}>
                              {({ countUpRef }) => (
                                <Box
                                  sx={{
                                    color: "#FFFF",
                                    fontSize: {
                                      xs: "20px",
                                      md: "30px",
                                      lg: "40px",
                                    },
                                    fontWeight: "bold",
                                  }}
                                >
                                  <span ref={countUpRef} />
                                </Box>
                              )}
                            </CountUp>
                          ) : (
                            ""
                          )}
                        </Box>
                      </Box>
                    </Box>

                    {/* buy ticket table  */}

                    {tickets.length > 0 ? (
                      <Box className="borderAnimation TicketBox">
                        <Box
                          id="lottery-tickets-list-wheellpage"
                          className={classes.list}
                        >
                          <InfiniteScroll
                            dataLength={tickets?.length}
                            next={() => fetchTickets(page)}
                            hasMore={hasMore}
                            loader={
                              <CircularProgress sx={{ marginInline: "auto" }} />
                            }
                            scrollableTarget="lottery-tickets-list-wheellpage"
                            style={{
                              overflow: "visible",
                              maxWidth: "400px",
                              marginInline: "auto",
                            }}
                          >
                            <Grid container spacing={{ md: 2, xs: 1 }}>
                              {/* <List
                            height={320} // same as Box maxHeight
                            itemCount={tickets.length}
                            itemSize={120} // adjust based on your ticket's height (+ padding)
                            width="100%"
                            itemData={{ tickets }} // pass data here
                          > */}

                              {memoizedTickets}
                              {/* </List> */}
                            </Grid>
                          </InfiniteScroll>
                        </Box>
                      </Box>
                    ) : (
                      <Box className="TicketBox">
                        <Box className={`animationBox borderAnimation`}>
                          <Box
                            className="animationText"
                            sx={{
                              display: "flex",
                              color: "white",
                              textShadow: "1px 1px 2px black",
                            }}
                          >
                            {ticketMsg}
                          </Box>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Grid>

                <Grid
                  item
                  xs={5}
                  md={5.5}
                  sx={{
                    display: "center",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      height: "100%",
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    <div
                      className="App"
                      style={{
                        fontFamily: "Nunito",
                        textAlign: "left",
                        position: "relative",
                        width: "100%",
                      }}
                    >
                      <div className="box-spin box-spin1 borderAnimation">
                        <div className="font-spin">
                          {hasJackpotStarted ? (
                            <div className="jackpot-header">
                              <span
                                style={{
                                  position: "relative",
                                  fontWeight: "bold",
                                  color: "#FFD700",
                                }}
                              >
                                Jackpot Spin
                              </span>
                              <span
                                className="wheel-arrow"
                                style={{
                                  position: "relative",
                                }}
                              >
                                <ArrowRightAltIcon />
                              </span>
                              <span
                                style={{
                                  position: "relative",
                                  fontWeight: "bold",
                                  color: "#FFF",
                                }}
                              >
                                <img
                                  src={whitet}
                                  height="14"
                                  width="14"
                                  style={{ marginRight: "4px" }}
                                  alt=""
                                />

                                <CurrencyFormat
                                  value={
                                    jackpotAmount
                                      ? parseFloat(
                                        jackpotAmount.toString()
                                      ).toFixed(2)
                                      : "0.00"
                                  }
                                  thousandSeparator={","}
                                  displayType={"text"}
                                  decimalSeparator={"."}
                                />
                              </span>
                            </div>
                          ) : (
                            <>
                              {showModal ? (
                                <Box className="jackpot-header">
                                  <span
                                    style={{
                                      position: "relative",
                                      top: "0px",
                                      paddingLeft: "40px",
                                      paddingRight: "40px",
                                    }}
                                  >
                                    {remainingTime ? (
                                      <Countdown
                                        date={new Date(remainingTime)}
                                      />
                                    ) : (
                                      <SkeletonLoader />
                                    )}
                                  </span>
                                </Box>
                              ) : (
                                <>
                                  <Box className="jackpot-header">
                                    <span
                                      style={{
                                        position: "relative",
                                        top: "0px",
                                      }}
                                    >
                                      Spin {countValue}
                                    </span>
                                    <span
                                      className="wheel-arrow"
                                      style={{ position: "relative" }}
                                    >
                                      <ArrowRightAltIcon />
                                    </span>
                                    <span
                                      style={{
                                        position: "relative",
                                        top: "0px",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <img
                                        src={whitet}
                                        height="14"
                                        width="14"
                                        style={{ marginRight: "4px" }}
                                        alt=""
                                      />
                                      {formatNumberWithCommas(lotterySpin[count])}
                                    </span>
                                  </Box>
                                </>
                              )}
                            </>
                          )}
                        </div>
                        <Box className="mob-screen-audio">
                          <audio ref={audioElement} src={sound} loop />
                          <IconButton
                            onClick={toggleMute}
                            sx={{ padding: { xs: "0", md: "0px" } }}
                          >
                            {isMuted ? (
                              <VolumeOffIcon sx={{ color: "white" }} />
                            ) : (
                              <VolumeUpIcon sx={{ color: "white" }} />
                            )}
                          </IconButton>
                        </Box>
                      </div>

                      <div className="speed">
                        <img src={speed} alt="speed" className="rpm2" />
                        <p style={{ color: "#fffff" }} className="speed3">
                          Break <br /> {decelaration.toFixed(2)}
                        </p>
                      </div>
                      {/* wheel code */}
                      <header className="App-header">
                        <div className="parent parent-div">
                          <div className="circle0 circle-zero">
                            <div className="outerImg"></div>
                          </div>
                          <div className="circle1 circle-first">
                            {getChildComp1}
                          </div>
                          <div className="circle2 circle-second" id="wheel-2">
                            {getChildComp2}
                          </div>
                          <div className="circle3 circle-third">
                            {getChildComp3}
                          </div>
                          <div className="circle4 circle-four">
                            {getChildComp4}
                          </div>
                          <div className="circle5 circle-five">
                            {getChildComp5}
                          </div>
                          <div className="circle6 circle-six">
                            {getChildComp6}
                          </div>

                          <div className="circle7 circle-seven">
                            <div
                              style={{
                                fontWeight: "bold",
                                textAlign: "center",
                                display: "block",
                              }}
                            ></div>
                          </div>
                          <div className="circle8 circle-eight">
                            <div
                              style={{
                                fontWeight: "bold",
                                textAlign: "center",
                                display: "block",
                              }}
                            >
                              <span className="spiner-circle">
                                {avgSpeed.toFixed(2)}
                              </span>
                            </div>
                          </div>
                        </div>
                        <Box className="animation">
                          <img
                            src="/Comp_1.gif"
                            alt="Background Animation"
                            className="background-video"
                          />
                        </Box>
                      </header>
                      <div className="rpm1">
                        <img src={rpm} alt="rpm" className="rpm2" />
                        <p style={{ color: "#fffff" }} className="rpm3">
                          RPM
                          <br /> {avgSpeed.toFixed(2)}
                        </p>
                      </div>
                    </div>
                  </Box>
                </Grid>

                <Grid item xs={3.5} md={3.2}>
                  <Box className="table-oriantation-fix">
                    {/* ball  animation box*/}
                    {ballToDisplay.length > 0 && (
                      <Box
                        className={classes.bollMoveBox}
                        sx={{
                          maxWidth: dynamicWidth ? `${dynamicWidth}` : "100%",
                        }}
                      >
                        <Box sx={{ textAlign: "center", width: "100%" }}>
                          <Box
                            className="container"
                            sx={{
                              position: "relative",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              width: "100%",
                              gap: "10px",
                              [theme.breakpoints.down("md")]: {
                                gap: "5px",
                              },
                            }}
                          >
                            {ballToDisplay.map((pos, index) => (
                              <Box
                                key={index}
                                className={`Three_dBollLook 
                                  ${clsx(classes.ball, {
                                  [classes.winnerBall]:
                                    isWinnerBallHighlighted &&
                                    pos.number ===
                                    spinningBallData?.randomGeneratedBall,
                                })}
                                  ${index > 4 ? "smallBall" : ""}
                                 
                                `}
                                style={{
                                  backgroundColor:
                                    colors[pos.number - 1]?.light || "gray",
                                  transform:
                                    isWinnerBallHighlighted &&
                                      pos.number ===
                                      spinningBallData?.randomGeneratedBall
                                      ? "scale(1)"
                                      : highlightedBallIndex === index
                                        ? "scale(1)"
                                        : "scale(1)",

                                  border:
                                    isWinnerBallHighlighted &&
                                      pos.number ===
                                      spinningBallData?.randomGeneratedBall
                                      ? "4px solid #FFD700" // Golden ring for winner ball
                                      : highlightedBallIndex === index ||
                                        isWinnerBallHighlighted
                                        ? "3px solid #fff" // White border for all in pop condition
                                        : "3px solid transparent",
                                  boxShadow:
                                    isWinnerBallHighlighted &&
                                      pos.number ===
                                      spinningBallData?.randomGeneratedBall
                                      ? "0 0 15px 5px rgba(255, 215, 0, 0.7)" // Golden glow effect
                                      : "none",
                                  transition:
                                    "transform 0.2s ease-in-out, border 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
                                  willChange: "transform, border, box-shadow",
                                }}
                              >
                                {pos.number}
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      </Box>
                    )}
                    {/* ticket table price */}
                    <Box className={`borderAnimation spinListBox`}>
                      <TableContainer
                        component={Paper}
                        className={`  ${classes.tableContainer}`}
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          gap: "10px",
                        }}
                      >
                        <Box className="tableActiveRow">
                          <Table
                            className={classes.table}
                            aria-label="custom table"
                            sx={{
                              minWidth: "auto !important",
                            }}
                          >
                            <TableHead
                              sx={{ backgroundColor: "#0D0D36 !important" }}
                            >
                              <TableRow>
                                <TableCell
                                  className={classes.tableHeader}
                                  sx={{
                                    width: "100%",
                                    p: {
                                      xs: "4px 6px !important",
                                      lg: "10px !important",
                                    },
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    gutterBottom
                                    sx={{
                                      color: "#FFFFFF",
                                      p: 0,
                                      fontSize: {
                                        xs: "10px !important",
                                        sm: "10px !important",
                                        lg: "14px !important",
                                      },
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    {lotteryNameData}
                                  </Typography>
                                </TableCell>

                                <TableCell
                                  className={classes.tableHeader}
                                  sx={{
                                    p: {
                                      xs: "4px 6px !important",
                                      lg: "10px !important",
                                    },
                                    minWidth: "40px",
                                    boxSizing: "content-box",
                                  }}
                                >
                                  <img
                                    className={classes.LotteryImageLogo}
                                    src={
                                      lotteryImage !== ""
                                        ? `${process.env.API_URL_PREFIX}/api/v1/admin/uploads/${lotteryImage}`
                                        : lotteryName
                                    }
                                    alt="lotteryName"
                                  />
                                </TableCell>
                              </TableRow>
                            </TableHead>
                          </Table>
                          <Table
                            className={`  ${classes.table}`}
                            aria-label="custom table"
                            cellPadding={3}
                          >
                            <TableBody>
                              <TableRow
                                key={0}
                                sx={{
                                  backgroundColor: "#3b97bb",
                                  opacity: "1",
                                }}
                              >
                                <TableCell
                                  className={classes.tableData}
                                  sx={{
                                    opacity: "1 !important",
                                    p: { xs: "4px 6px", lg: "10px" },
                                    borderBottom: "none !important",
                                    lineHeight: "1px",
                                  }}
                                >
                                  <p style={{ width: "max-content" }}>
                                    Total Prize money
                                  </p>
                                </TableCell>

                                <TableCell
                                  className={classes.tableData}
                                  sx={{
                                    textAlign: "start",
                                    opacity: "1 !important",
                                    p: { xs: "4px 6px", lg: "10px" },
                                    borderBottom: "none !important",
                                    lineHeight: "1px",
                                    width: "60px",
                                  }}
                                >
                                  <img
                                    src={whitet}
                                    height="13"
                                    width="13"
                                    alt=""
                                    style={{ marginRight: "3px" }}
                                  />

                                  <CurrencyFormat
                                    value={
                                      lotterySpin.length > 0
                                        ? lotterySpin.reduce(
                                          (acc, curr) => acc + parseFloat(curr),
                                          0
                                        )
                                        : 0
                                    }
                                    thousandSeparator={","}
                                    displayType={"text"}
                                    decimalSeparator={"."}
                                  />
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </Box>
                        <Box
                          ref={tableContainerRef}
                          className="tableActiveRow middleSpinList"
                          sx={{
                            maxHeight: {
                              xs: "calc(100% - 110px) !important !important",
                            },
                            height: "100%",
                            overflowY: "auto",
                            minWidth: {
                              lg: "230px !important",
                              xs: "140px !important",
                            },
                          }}
                        >
                          <Table
                            className={classes.table}
                            aria-label="custom table"
                          >
                            <TableBody
                              className={classes.list}
                              sx={{
                                mt: "20px",
                                paddingRight: "0px !important",
                              }}
                            >
                              {lotterySpin.map((row, index) => (
                                <TableRow
                                  key={index + 1}
                                  ref={(el) => (rowRefs.current[index] = el)}
                                  sx={{
                                    borderBottom: "1px solid #0D0D39",
                                  }}
                                  className={
                                    index === count && jackpotCount == 0
                                      ? "active"
                                      : "inactive"
                                  }
                                >
                                  <TableCell
                                    className={classes.tableData}
                                    colSpan={2}
                                    sx={{
                                      borderBottom: "none !important",
                                      lineHeight: "1px",
                                      p: { xs: "2px 8px", lg: "10px" },
                                    }}
                                  >
                                    <p className="m-0 mw-max ">
                                      <span className="dotIcon"></span>{" "}
                                      {getOrdinalSuffix(index + 1) +
                                        " " +
                                        "Spin"}
                                    </p>
                                  </TableCell>

                                  <TableCell
                                    className={classes.tableData}
                                    sx={{
                                      textAlign: "start",
                                      borderBottom: "none !important",
                                      lineHeight: "1px",
                                      p: {
                                        xs: "4px 6px !important",
                                        lg: "10px !important",
                                      },
                                      width: "60px",
                                    }}
                                  >
                                    <span
                                      className={
                                        index === count && jackpotCount == 0
                                          ? "active"
                                          : "inactive"
                                      }
                                    >
                                      {index === count && jackpotCount == 0 ? (
                                        <img
                                          src={yellowt}
                                          height="12"
                                          width="12"
                                          style={{
                                            verticalAlign: "middle",
                                            marginRight: "4px",
                                          }}
                                          alt=""
                                        />
                                      ) : (
                                        <img
                                          src={whitet}
                                          height="12"
                                          width="12"
                                          style={{
                                            verticalAlign: "middle",
                                            marginRight: "4px",
                                          }}
                                          alt=""
                                        />
                                      )}

                                      <CurrencyFormat
                                        value={lotterySpin[index]}
                                        thousandSeparator={","}
                                        displayType={"text"}
                                        decimalSeparator={"."}
                                      />
                                    </span>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </Box>
                        <Box
                          className="tableActiveRow"
                          sx={{
                            height: "auto",
                            minWidth: {
                              lg: "230px !important",
                              xs: "140px !important",
                            },
                          }}
                        >
                          <Table
                            className={classes.table}
                            aria-label="custom table"
                          >
                            <TableBody
                              className={classes.list}
                              sx={{
                                mt: "20px",
                                paddingRight: "0px !important",
                              }}
                            >
                              {jackpotSelected ? (
                                <TableRow
                                  key={0}
                                  sx={{
                                    opacity: "1",
                                  }}
                                  className={
                                    jackpotCount == 1 ? "active" : "inactive"
                                  }
                                >
                                  <TableCell
                                    className={classes.tableData}
                                    sx={{
                                      opacity: "1 !important",
                                      p: { xs: "4px 6px", lg: "10px" },
                                      borderBottom: "none !important",
                                      lineHeight: "1px",
                                    }}
                                  >
                                    <p style={{ width: "max-content" }}>
                                      Jackpot Spin
                                    </p>
                                  </TableCell>

                                  <TableCell
                                    className={classes.tableData}
                                    sx={{
                                      textAlign: "start",
                                      opacity: "1 !important",
                                      p: { xs: "4px 6px", lg: "10px" },
                                      borderBottom: "none !important",
                                      lineHeight: "1px",
                                      width: "60px",
                                    }}
                                  >
                                    {jackpotCount == 1 ? (
                                      <img
                                        src={yellowt}
                                        height="12"
                                        width="12"
                                        style={{
                                          verticalAlign: "middle",
                                          marginRight: "4px",
                                        }}
                                        alt=""
                                      />
                                    ) : (
                                      <img
                                        src={whitet}
                                        height="12"
                                        width="12"
                                        style={{
                                          verticalAlign: "middle",
                                          marginRight: "4px",
                                        }}
                                        alt=""
                                      />
                                    )}
                                    <span
                                      className={
                                        jackpotCount == 1
                                          ? "active"
                                          : "inactive"
                                      }
                                    >
                                      <CurrencyFormat
                                        value={
                                          lastLotteryData?.jackpotAccumulatedAmt
                                            ? parseFloat(
                                              lastLotteryData.jackpotAccumulatedAmt
                                            )
                                            : 0
                                        }
                                        thousandSeparator={","}
                                        displayType={"text"}
                                        decimalSeparator={"."}
                                      />
                                    </span>
                                  </TableCell>
                                </TableRow>
                              ) : (
                                ""
                              )}
                            </TableBody>
                          </Table>
                        </Box>
                      </TableContainer>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>

          {WinnerArray.length <= countValue && hasCompletedRotation ? (
            <Box sx={{ p: { md: "30px", xs: "15px" } }}>
              <Grid container spacing={2} sx={{ marginBottom: "20px" }}>
                <Grid item xs={12}>
                  <Typography
                    ref={scrollRef}
                    component="h4"
                    variant="h4"
                    sx={{
                      mb: "20px",
                      fontSize: "20px !important",
                      fontWeight: 500,
                    }}
                  >
                    Winning Tickets
                  </Typography>
                  
                  {/* Full width for horizontal strip */}
                  <WinningHistoryWheel />
                </Grid>
              </Grid>
            </Box>
          ) : (
            ""
          )}

          <WinModal
            open={isWinOpen}
            onClose={handleWinClose}
            winnerPrize={lotterySpin[count]}
            ticketNumber={WinnerArray[count]}
            countIndex={count}
            hasLotteryWin={hasLotteryWin}
            hasFreeTicketWin={hasFreeTicketWin}
          />
          <LostModal
            open={isLostOpen}
            onClose={handleLostClose}
            message={message}
          />
          <PrizeModal open={isPrizeOpen} onClose={handlePrizeClose} />

          {jackpotWinningData &&
            (jackpotWinningData?.winningStatus == 1 ? (
              <JackpotWinModal
                open={isJackpotWinOpen}
                onClose={handleJackpotWinClose}
                JackpotPrize={jackpotWinningData?.jackpotWinnerDetail?.prize}
                jackpotRound={jackpotWinningData?.jackpotWinnerDetail?.round}
              />
            ) : jackpotWinningData?.winningStatus == 2 ? (
              <JackpotMoveToNextLotteryModal
                open={isJackpotMoveToNextLottery}
                onClose={handleJackpotMoveToNextLotteryClose}
                message={
                  "Sorry, you did not win. Fingers crossed for the next Jackpot."
                }
              />
            ) : (
              <JackpotLostModal
                open={isJackpotLostOpen}
                onClose={handleJackpotLostClose}
                message={
                  "Sorry, you did not win. Fingers crossed for the next Jackpot."
                }
              />
            ))}

          <JackpotModal
            open={showjackpotModal}
            onClose={handleJackpotModalClose}
            handleStartJackpotDraw={handleStartJackpotDraw}
          />

          {lotteryPool ? (
            <LotteryPoolModal
              open={lotteryPool}
              onClose={handleLotteryPoolClose}
              noOfTicketsSold={noOfTicketsSold}
              percentageOfticketsSold={percentageOfTicketSold}
              totalPrizeofTickets={totalPrizeOfTicket}
              handleStartDraw={handleStartDraw}
            />
          ) : null}

          {isWinOpen ? (
            <Particles
              id="tsparticles"
              init={particlesInit}
              options={{
                preset: "fireworks",
                particles: {
                  color: {
                    value: [
                      "#5bc0eb",
                      "#fde74c",
                      "#9bc53d",
                      "#e55934",
                      "#fa7921",
                    ],
                  },
                  background: {
                    color: {
                      value: "transparent",
                    },
                    background: {
                      color: {
                        value: "#000000",
                      },
                    },
                    fpsLimit: 120,
                    interactivity: {
                      events: {
                        onClick: {
                          enable: true,
                          mode: "push",
                        },
                        onHover: {
                          enable: false,
                          mode: "repulse",
                        },
                        resize: true,
                      },
                      modes: {
                        bubble: {
                          distance: 400,
                          duration: 2,
                          opacity: 0.8,
                          size: 40,
                        },
                        push: {
                          quantity: 4,
                        },
                        repulse: {
                          distance: 200,
                          duration: 0.4,
                        },
                      },
                    },
                    particles: {
                      color: {
                        value: "#ffffff",
                      },
                      links: {
                        color: "#ffffff",
                        distance: 150,
                        enable: false,
                        opacity: 0.4,
                        width: 1,
                      },
                      collisions: {
                        enable: true,
                      },
                      move: {
                        direction: "none",
                        enable: true,
                        outMode: "bounce",
                        random: true,
                        speed: 2,
                        straight: false,
                      },
                      fullScreen: {
                        enable: true,
                        zIndex: 0,
                      },
                      number: {
                        density: {
                          enable: true,
                          area: 500,
                        },
                        value: 80,
                      },
                      opacity: {
                        value: 0.5,
                      },
                      shape: {
                        type: "circle",
                      },
                      size: {
                        random: true,
                        value: 1,
                      },
                    },
                    detectRetina: true,
                    fullScreen: {
                      enable: true,
                      zIndex: -1,
                    },
                  },
                },
              }}
            />
          ) : (
            ""
          )}

          {isJackpotWinOpen ? (
            <Particles
              id="tsparticles"
              init={particlesInit}
              options={{
                preset: "fireworks",
                particles: {
                  color: {
                    value: [
                      "#5bc0eb",
                      "#fde74c",
                      "#9bc53d",
                      "#e55934",
                      "#fa7921",
                    ],
                  },
                  background: {
                    color: {
                      value: "transparent",
                    },
                    background: {
                      color: {
                        value: "#000000",
                      },
                    },
                    fpsLimit: 120,
                    interactivity: {
                      events: {
                        onClick: {
                          enable: true,
                          mode: "push",
                        },
                        onHover: {
                          enable: false,
                          mode: "repulse",
                        },
                        resize: true,
                      },
                      modes: {
                        bubble: {
                          distance: 400,
                          duration: 2,
                          opacity: 0.8,
                          size: 40,
                        },
                        push: {
                          quantity: 4,
                        },
                        repulse: {
                          distance: 200,
                          duration: 0.4,
                        },
                      },
                    },
                    particles: {
                      color: {
                        value: "#ffffff",
                      },
                      links: {
                        color: "#ffffff",
                        distance: 150,
                        enable: false,
                        opacity: 0.4,
                        width: 1,
                      },
                      collisions: {
                        enable: true,
                      },
                      move: {
                        direction: "none",
                        enable: true,
                        outMode: "bounce",
                        random: true,
                        speed: 2,
                        straight: false,
                      },
                      fullScreen: {
                        enable: true,
                        zIndex: 0,
                      },
                      number: {
                        density: {
                          enable: true,
                          area: 500,
                        },
                        value: 80,
                      },
                      opacity: {
                        value: 0.5,
                      },
                      shape: {
                        type: "circle",
                      },
                      size: {
                        random: true,
                        value: 1,
                      },
                    },
                    detectRetina: true,
                    fullScreen: {
                      enable: true,
                      zIndex: -1,
                    },
                  },
                },
              }}
            />
          ) : (
            ""
          )}
        </Box>
      )}
    </>
  );
};
